import React from 'react';
import FadeIn from '../common/FadeIn';
import about2 from '../../assets/images/about2.png';

const AboutStrategySection = () => {
  return (
    <section className="w-full bg-[#f9f9f5] text-[#1C1917] sticky top-0 z-20 min-h-screen flex flex-col justify-center overflow-hidden">
      <div className="w-full grid grid-cols-1 lg:grid-cols-2 items-stretch min-h-screen">

        <div className="w-full bg-[#f9f9f5] flex flex-col justify-center items-end p-8 sm:p-12 md:p-16 lg:p-20 order-2 lg:order-1">
          <div className="max-w-[540px] mx-auto lg:mx-0">
            <FadeIn>
              <h2 className="font-saolDisplayItalic md:text-[70px] text-[40px] leading-[1] font-normal tracking-[0em] mb-7 sm:mb-9">
                Thoughtful Design, Made Simple
              </h2>
            </FadeIn>

            <FadeIn>
              <p className="font-interDisplayMedium text-[14px] md:text-[17px] font-light text-black leading-[1.6] tracking-[0em] mb-6">
                I start with a website design you like and make it work for your business.
              </p>
            </FadeIn>

            <FadeIn>
              <p className="font-interDisplayMedium text-[14px] md:text-[17px] font-light text-black leading-[1.6] tracking-[0em] mb-6">
                Your content, images, logo, colors, and other details are added to the design so it matches your brand and style.
              </p>
            </FadeIn>

            <FadeIn>
              <p className="font-interDisplayMedium text-[14px] md:text-[17px] font-light text-black leading-[1.6] tracking-[0em] mb-6">
                Simple process. Clean design. Your website.
              </p>
            </FadeIn>
          </div>
        </div>

        <FadeIn className="w-full h-full min-h-[380px] sm:min-h-[480px] lg:min-h-full self-stretch bg-[#EFECE6] flex items-center justify-center relative overflow-hidden order-1 lg:order-2">
          <img
            src={about2}
            alt="Princy Patel - Thoughtful Website Design & Portfolio Styling"
            className="w-full h-full object-cover object-center"
            loading="lazy"
            decoding="async"
            width="600"
            height="800"
          />
        </FadeIn>

      </div>
    </section>
  );
};

export default AboutStrategySection;
